export enum ReportOptionsControl {
  CHECKBOX = 'CHECKBOX',
  COMBOBOX = 'COMBOBOX',
}
